function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useActionSheet } from "@expo/react-native-action-sheet";
import * as Sentry from "@sentry/core";
import { LinearGradient } from "expo-linear-gradient";
import { memo } from "react";
import { Image, StyleSheet } from "react-native";
import { Button } from "./Button";
import { View } from "./View";
import { AccessibleInput } from "../hooks/useAccessibleInput";
import { useI18n } from "../lib/i18n";
import { launchMediaPickerAsync } from "../lib/launchMediaPickerAsync";
var ImageLinearGradient = /*#__PURE__*/ memo(function() {
    return /*#__PURE__*/ _jsx(LinearGradient, {
        colors: [
            'transparent',
            'rgba(0,0,0,0.5)'
        ],
        style: [
            StyleSheet.absoluteFillObject
        ],
        start: [
            0,
            0
        ],
        end: [
            0,
            1
        ]
    });
});
var assetDetailsCache = new Map();
/**
 * @nosync
 */ export function getImageInputAssetDetails(uri) {
    return assetDetailsCache.get(uri);
}
/**
 * An input field for an image asset. Value is a URI string
 *
 *
 *
 * **No value**
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̄̀̀̃́̀̀̂̎̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̇̀̀̂̌̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̉̀̀̆̂̀̀̃̉̀̀̆̂̀̀̃̀̀̀̃̆̀̀̃́̀̀̆̂̀̀̂̍̀̀̃̉̀̀̃̃̀̀̃̅̀̀̃̆̀̀̂̍̀̀̃̄̀̀̆́̀̀̃̆̀̀̃̇̀̀̂̍̀̀̆́̀̀̆̅̀̀̆̂̀̀̃̀̀̀̂̍̀̀̃̅̀̀̃̄̀̀̃̉̀̀̃́̀̀̃̀̀̀̃̈̀̀̃̆̀̀̆̅̀̀̆̄̀̀̃̉̀̀̃̄̀̀̃̈̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̇̀̀̃̂̀̀̃̃̀̀̂̍̀̀̃̂̀̀̃́̀̀̃̀̀̀̃̃̀̀̃̀̀̀̃̅̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̇̀̀̃́̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̅̀̀̃̆̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 *
 *
 * **With value**
 *
 *
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃́̀̀̃́̀̀̃̄̀̀̆̂̀̀̆̂̀̀̃̅̀̀̃̀̀̀̆̃̀̀̂̍̀̀̆̆̀̀̃̅̀̀̆́̀̀̃́̀̀̂̍̀̀̃̄̀̀̃̈̀̀̃̅̀̀̃̂̀̀̂̍̀̀̃̈̀̀̃̅̀̀̃̃̀̀̆̆̀̀̂̍̀̀̃̉̀̀̃̉̀̀̃̂̀̀̆̅̀̀̃́̀̀̆̃̀̀̃̀̀̀̆̅̀̀̃̆̀̀̃̉̀̀̆̃̀̀̃̃̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̇̀̀̃̂̀̀̃̃̀̀̂̍̀̀̃̂̀̀̃́̀̀̃̀̀̀̃̃̀̀̃̂̀̀̃̉̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̆̀̀̃̉̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̆̀̀̃̀̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-7}
 */ export function ImageInput(_param) {
    var value = _param.value, chooseImageLabel = _param.chooseImageLabel, changeImageLabel = _param.changeImageLabel, onChangeValue = _param.onChangeValue, accessibleProps = _object_without_properties(_param, [
        "value",
        "chooseImageLabel",
        "changeImageLabel",
        "onChangeValue"
    ]);
    var showActionSheetWithOptions = useActionSheet().showActionSheetWithOptions;
    var $t = useI18n().$t;
    var choosePhoto = function() {
        return showActionSheetWithOptions({
            options: [
                $t({
                    id: 'ImageInput_choosePhotoCancelOption',
                    defaultMessage: 'Cancel'
                }),
                $t({
                    id: 'ImageInput_choosePhotoGalleryOption',
                    defaultMessage: 'Choose from gallery'
                }),
                $t({
                    id: 'ImageInput_choosePhotoCameraOption',
                    defaultMessage: 'Take a photo'
                })
            ],
            cancelButtonIndex: 0
        }, /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(buttonIndex) {
                var useGallery, promise;
                return _ts_generator(this, function(_state) {
                    if (typeof buttonIndex !== 'number') return [
                        2
                    ];
                    if (buttonIndex > 0) {
                        useGallery = buttonIndex === 1;
                        promise = launchMediaPickerAsync(useGallery ? 'gallery' : 'camera');
                        promise.then(function(result) {
                            if (!result.canceled) {
                                assetDetailsCache.set(result.assets[0].uri, result.assets[0]);
                                onChangeValue(result.assets[0].uri);
                            }
                        }).catch(Sentry.captureException);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(buttonIndex) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    return /*#__PURE__*/ _jsx(AccessibleInput, _object_spread_props(_object_spread({}, accessibleProps), {
        children: function(_accessibilityProps) {
            return /*#__PURE__*/ _jsx(View, {
                style: {
                    overflow: 'hidden',
                    borderRadius: 10
                },
                children: value ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            source: {
                                uri: value
                            },
                            style: {
                                aspectRatio: 1,
                                alignSelf: 'stretch',
                                borderRadius: 10
                            }
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                bottom: 0,
                                padding: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsx(ImageLinearGradient, {}),
                                /*#__PURE__*/ _jsxs(View, {
                                    row: true,
                                    style: {
                                        justifyContent: 'space-between'
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            icon: "upload",
                                            text: changeImageLabel || 'Replace',
                                            variant: "text",
                                            color: "white",
                                            onPress: choosePhoto,
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            icon: "bin",
                                            text: "Delete",
                                            variant: "text",
                                            color: "white",
                                            onPress: function() {
                                                return onChangeValue(null);
                                            },
                                            size: "small"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(Button, {
                    text: chooseImageLabel || 'Choose',
                    icon: "plus",
                    onPress: choosePhoto
                })
            });
        }
    }));
}
